module.exports = __webpack_public_path__ + "img/logo-birth.bb2fb65.webp";